import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TranslocoService} from "@ngneat/transloco";
import {MatDialog} from "@angular/material/dialog";
import {Compbaser} from "../compbaser";

export interface IButtonBar {
    name: string;
    callBack: (v) => void;
    icon: string;
    disableByList: boolean;
    disabled: boolean;
    tooltip?: string;
    showTooltipAsText?: boolean;
    confirmRemove?: string;
    hidden?: boolean;
    callbackStatus?: (v) => boolean; // Set table-list buttons disabled status: if true, button is disabled, else, button is activated.
    callbackIcon?: (v) => string; // Set table-list buttons disabled status: if true, button is disabled, else, button is activated.
}

@Component({
    selector: 'app-button-bar',
    templateUrl: './button-bar.component.html',
    styleUrls: ['./button-bar.component.scss']
})
export class ButtonBarComponent extends Compbaser implements OnInit {
    // @Output() add: EventEmitter<any> = new EventEmitter();
    // @Output() remove: EventEmitter<any> = new EventEmitter();
    // @Input() setRemove = false;
    // @Input() setAdd = true;

    @Output() buttonEmit: EventEmitter<any> = new EventEmitter();
    @Input() className = '';

    @Input() set setButtons(i_buttons: IButtonBar[]) {
        this.buttons = i_buttons;
        this.updateButtonDisability();
    }

    @Input() set items(i_items: Array<any>) {
        this.m_items = i_items;
        this.updateButtonDisability();
    }

    m_items: Array<any> = [];
    buttons: IButtonBar[] = [];

    constructor(private translocoService: TranslocoService, public override dialog: MatDialog, private cd: ChangeDetectorRef) {
        super(dialog);
    }

    ngOnInit() {
    }

    private updateButtonDisability() {
        this.buttons.forEach((v) => {
            if (v.disableByList) {
                v.disabled = this.m_items.length === 0;
                // this.disableButton(v.name, status);
            }

            if (v.callbackStatus) {
                const status = v.callbackStatus(this.m_items);
                v.disabled = status;
            }
        });
        this.cd.markForCheck();
    }

    public disableButton(buttonName: string, value: boolean) {
        this.buttons.forEach((v) => {
            if (v.name === buttonName) {
                v.disabled = value;
            }
        });
        this.cd.markForCheck();
    }

    onClick(button: IButtonBar, event) {
        // event.stopImmediatePropagation();
        // event.preventDefault();
        this.buttons.forEach((v) => {
            if (v.name === button.name && !v.disabled) {
                if (v.confirmRemove) return this.onConfirmMessage(v);
                this.buttonEmit.emit(v);
                if (v.callBack) v.callBack(v);
            }
        });
        // return false;
    }

    onConfirmMessage(v) {
        return this.openDialog(this.translocoService.translate(v.confirmRemove, {}, this.translocoService.getActiveLang()), {showCancel: true}, (r) => {
            if (r) {
                this.buttonEmit.emit(v);
                if (v.callBack) v.callBack(v);
            }
        });
    }
}
